import { render, staticRenderFns } from "./ProfileDropdownMenu.vue?vue&type=template&id=89486ab8&scoped=true&"
import script from "./ProfileDropdownMenu.vue?vue&type=script&lang=ts&"
export * from "./ProfileDropdownMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileDropdownMenu.vue?vue&type=style&index=0&id=89486ab8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89486ab8",
  null
  
)

export default component.exports